import {
    apiRequest,
    skpnsCreate,
    masterRank,
    masterSignatoryOfficial,
    masterDocumentType
} from "../../../../../services/adapters/kepegawaian/skpnsService"

class CreateRepository {

    fetchCreate = async (query) => {
        return await apiRequest("post", skpnsCreate, {
            body: query
        }, true)
    }

    fetchRank = async (query) => {
        return await apiRequest("get", masterRank, {
            params: query
        }, true)
    }

    fetchSignatoryOfficial = async (query) => {
        return await apiRequest("get", masterSignatoryOfficial, {
            params: query
        }, true)
    }

    
    fetchDocumentType = async (query) => {
        return await apiRequest("get", masterDocumentType, {
            params: query
        }, true)
    }

}

export default CreateRepository